import { DialogRoute } from 'bernie-core';
import { Layer } from 'bernie-view';
import * as React from 'react';
import { useLocalization } from '@shared-ui/localization-context';
import { Link as RouterLink } from 'react-router-dom';
import { UitkDialogContent, UitkFullscreenDialog, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkToolbar, ToolbarType } from 'uitk-react-toolbar';
import { UitkLink } from 'uitk-react-link';
import { UitkText } from 'uitk-react-text';
import { ActivityDestinationViewSearch } from '../../common/__generated__/api';
import { useStores } from '../../utils/hooks';
import ActivityPopupClickAction = ActivityDestinationViewSearch.ActivityPopupClickActionInlineFragment;

export interface ActivityMessageDialogProps {
  activityMessageAction: ActivityDestinationViewSearch.First | ActivityDestinationViewSearch.Second;
}

export const ActivityMessageDialog: React.FC<ActivityMessageDialogProps> = ({ activityMessageAction }) => {
  const { analytics, routeStore } = useStores();
  const { formatText } = useLocalization();
  const clickAction = activityMessageAction.clickAction as ActivityPopupClickAction;
  const uniqueDialogId = 'activity-message-dialog';

  const onDismiss = (): void => {
    if (clickAction.dismissAction?.rfrr) {
      analytics.trackEvent(clickAction.dismissAction?.rfrr, 'RFRR Action Link', analytics.omnitureData, null, true);
    }
    routeStore.closeDialog();
  };

  return (
    <>
      <DialogRoute id={uniqueDialogId}>
        <Layer id="activity-message-dialog" onDismiss={onDismiss}>
          <UitkFullscreenDialog dialogShow={true}>
            <UitkToolbar
              action={onDismiss}
              header={clickAction.text ? clickAction.text : ''}
              iconLabel="Close the dialog"
              key="UitkToolbar"
              type={ToolbarType.CLOSE}
            />
            <UitkDialogContent>
              <UitkText size={300}>
                {clickAction.text.split('\n').map((value, index) => (
                  <p key={index}>{value}</p>
                ))}
              </UitkText>
            </UitkDialogContent>
            <UitkDialogFooter
              buttonOne={{
                onClick: onDismiss,
                text: formatText('lx.search.form.close'),
                type: 'tertiary'
              }}
            />
          </UitkFullscreenDialog>
        </Layer>
      </DialogRoute>
      <UitkLink inline={true}>
        <RouterLink
          to={{
            pathname: routeStore.pathname,
            search: routeStore.mergeQueryString(routeStore.search, {
              pwaDialog: uniqueDialogId
            })
          }}
          role="button"
        >
          {activityMessageAction.text}
        </RouterLink>
      </UitkLink>
    </>
  );
};
